import { render, staticRenderFns } from "./PayeeInfoButton.vue?vue&type=template&id=16d3dfe8&"
import script from "./PayeeInfoButton.vue?vue&type=script&lang=ts&"
export * from "./PayeeInfoButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports